<template lang="pug">
v-dialog(v-model='dialog' scrollable persistent max-width='80%')
  v-card
    v-card-title
      span.headline {{ formTitle }}
    v-divider(light)
    v-card-text
      v-container
        v-row(v-show='read && orden.estatus ==="pendiente"'  align='center' dense)
          v-col(cols='12' sm='12' md='6')
            v-text-field(v-if='orden && orden.idEmpresa && orden.idEmpresa.nombre' dense outlined :readonly='read' v-model='orden.idEmpresa.nombre' label='Nombre')
          v-col( cols='12' sm='12' md='6')
            v-text-field(v-if='orden && orden.idEmpresa && orden.idEmpresa.telf' dense outlined :readonly='read' v-model='orden.idEmpresa.telf' label='Telefono' v-mask="'(####)###-##-##'")
          v-col(cols='12' sm='12' md='12')
            v-data-table.elevation-1(dense='' v-if='orden && orden.productos' :headers='headers' :items='orden.productos')
              template(v-slot:top)
                v-toolbar(flat dense color='primary' dark)
                  v-toolbar-title.justify-center(color='success') Productos Solicitados
              template(v-slot:no-data)
                h1 No existen Productos asociados
        v-row(v-show='!read'  align='center' dense)
          v-flex(xs12)
            v-layout(wrap='')
              v-flex(xs12 sm12 md6)
                v-layout(wrap='')
                  v-flex(xs12 sm12 md6 style='padding: 5px;')
                    v-text-field(v-if='orden && orden.idEmpresa && orden.idEmpresa.nombre' dense outlined :readonly='true' v-model='orden.idEmpresa.nombre' label='Nombre')
                  v-flex(xs12 sm12 md6 style='padding: 5px;')
                    v-text-field(v-if='orden && orden.idEmpresa && orden.idEmpresa.telf' dense outlined :readonly='true' v-model='orden.idEmpresa.telf' label='Telefono' v-mask="'(####)###-##-##'")
                  v-flex(xs12 sm12 md12 style='padding: 5px;')
                    v-data-table.elevation-1(dense='' v-if='orden && orden.productos' :headers='headers' :items='orden.productos')
                      template(v-slot:top)
                        v-toolbar(flat dense color='primary' dark)
                          v-toolbar-title.justify-center(color='success') Productos Solicitados
                      template(v-slot:no-data)
                        h1 No existen Productos asociados
              v-flex(xs12 sm12 md6)
                v-layout(wrap='')
                  v-flex(xs12 sm12 md6 style='padding: 5px;')
                    v-text-field(dense outlined :readonly='read' v-model='form.diaCredito' label='Días de crédito' type='number' min='0')
                  v-flex(xs12 sm12 md6 style='padding: 5px;')
                    v-text-field(dense outlined :readonly='read' v-model='form.diaDespacho' label='Días de despacho' type='number' min='1')
                  v-flex(xs12 sm12 md12 style='padding: 5px;')
                    v-data-table.elevation-1(dense='' :headers='headers2' :items='productos')
                      template(v-slot:top)
                        v-toolbar(flat dense color='primary' dark)
                          v-toolbar-title.justify-center(color='success') Productos Cotizados
                          v-spacer
                          v-btn.mx-2(fab dark small color='success' @click='dialog2 = true' )
                              v-icon(dark) mdi-plus
                      template(v-slot:item.action='{ item }')
                        v-tooltip(bottom='')
                          template(v-slot:activator='{ on }')
                            v-icon.mr-2(color='error' @click='eliminar(item)') mdi-delete
                          | Eliminar
                      template(v-slot:no-data)
                        h1 No existen Productos asociados
                    v-dialog(v-model='dialog2' scrollable persistent max-width='50%')
                      v-card
                        v-card-title
                          span.headline Productos
                        v-divider(light)
                        v-card-text
                          v-container
                            v-row(align='center' dense)
                              v-col(cols='12' sm='12' md='12')
                                v-select(dense outlined :readonly='read' v-model='seleccion' :items="selectpro" label='Producto')
                              v-col( cols='12' sm='12' md='12')
                                v-text-field(v-if='seleccion' dense outlined v-model='cantidad' label='Cantidad')
                              v-col( cols='12' sm='12' md='12')
                                v-text-field(v-if='seleccion' dense outlined v-model='costo' label='Costo')
                        v-card-actions
                          v-spacer
                          v-btn(color='error' small dark @click='close2')
                            v-icon mdi-close
                            | Cancelar
                          v-btn(v-if='!read' color='success' small dark @click='agregar')
                            v-icon mdi-content-save
                            | Guardar
        v-row(v-show='read && orden.estatus === "cotizada"'  align='center' dense)
          v-flex(xs12)
            v-layout(wrap='')
              v-flex(xs12 sm12 md6)
                v-layout(wrap='')
                  v-flex(xs12 sm12 md6 style='padding: 5px;')
                    v-text-field(v-if='orden && orden.idEmpresa && orden.idEmpresa.nombre' dense outlined :readonly='true' v-model='orden.idEmpresa.nombre' label='Nombre')
                  v-flex(xs12 sm12 md6 style='padding: 5px;')
                    v-text-field(v-if='orden && orden.idEmpresa && orden.idEmpresa.telf' dense outlined :readonly='true' v-model='orden.idEmpresa.telf' label='Telefono' v-mask="'(####)###-##-##'")
                  v-flex(xs12 sm12 md12 style='padding: 5px;')
                    v-data-table.elevation-1(dense='' v-if='orden && orden.productos' :headers='headers' :items='orden.productos')
                      template(v-slot:top)
                        v-toolbar(flat dense color='primary' dark)
                          v-toolbar-title.justify-center(color='success') Productos Solicitados
                      template(v-slot:no-data)
                        h1 No existen Productos asociados
              v-flex(xs12 sm12 md6)
                v-layout(wrap='')
                  v-flex(xs12 sm12 md6 style='padding: 5px;')
                    v-text-field(dense outlined :readonly='true' v-model='form.diaCredito' label='Días de crédito' type='number' min='0')
                  v-flex(xs12 sm12 md6 style='padding: 5px;')
                    v-text-field(dense outlined :readonly='true' v-model='form.diaDespacho' label='Día de despacho' persistent-hint='' append-icon='event' readonly='')
                  v-flex(xs12 sm12 md12 style='padding: 5px;')
                    v-data-table.elevation-1(dense='' :headers='headers2' :items='productos')
                      template(v-slot:top)
                        v-toolbar(flat dense color='primary' dark)
                          v-toolbar-title.justify-center(color='success') Productos Cotizados
                      template(v-slot:no-data)
                        h1 No existen Productos asociados
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(v-if='!read' color='success' small dark @click='save')
          v-icon mdi-content-save
          | Guardar
</template>

<script>
import Api from '@/services/methods'
export default {
  props: ['dialog', 'read', 'orden', 'view'],
  name: 'CotizacionM',
  data: vm => ({
    search: '',
    dialog2: false,
    seleccion: '',
    descripcion: '',
    cantidad: '',
    costo: '',
    selectpro: [],
    form: {
      diaCredito: 0,
      diaDespacho: 1,
      total: '',
      productos: [],
      idProveedor: ''
    },
    productos: [],
    headers: [
      { text: 'Nombre', align: 'left', value: 'idProducto.descripcion' },
      { text: 'Cantidad', value: 'cantidadPedido' }
    ],
    headers2: [
      { text: 'Nombre', align: 'left', value: 'prod.descripcion' },
      { text: 'Cantidad', value: 'cantidad' },
      { text: 'Costo', value: 'costo' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    defaultForm: {
      diaCredito: 0,
      diaDespacho: 1,
      total: '',
      productos: [],
      idProveedor: ''
    }
  }),

  watch: {
    view (val) {
      if (val) {
        this.form.diaCredito = val.diaCredito
        this.form.diaDespacho = val.diaDespacho
        this.productos = []
        for (let i = 0; i < val.productos.length; i++) {
          this.productos.push({ prod: { _id: val.productos[i].idProducto._id, descripcion: val.productos[i].idProducto.descripcion }, cantidad: val.productos[i].cantidad, costo: val.productos[i].costo })
        }
      }
    },
    seleccion (val) {
      for (let i = 0; i < this.orden.productos.length; i++) {
        if (this.orden.productos[i].idProducto._id === val) {
          this.cantidad = this.orden.productos[i].cantidadPedido
          this.descripcion = this.orden.productos[i].idProducto.descripcion
        }
      }
    },
    date (val) {
      this.form.diaDespacho = this.formatDate(this.date)
    },
    orden (val) {
      if (val) {
        this.selectpro = []
        for (let i = 0; i < val.productos.length; i++) {
          this.selectpro.push({
            text: val.productos[i].idProducto.descripcion,
            value: val.productos[i].idProducto._id
          })
        }
      }
    }
  },

  created () {
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Crear Cotización'
        : this.read
          ? 'Informacion de la orden'
          : 'Crear Cotización'
    }
  },

  methods: {
    eliminar (item) {
      for (let i = 0; i < this.productos.length; i++) {
        if (this.productos[i].prod._id === item.prod._id) {
          this.selectpro.push({ value: this.productos[i].prod._id, text: this.productos[i].prod.descripcion })
          this.productos.splice(i, 1)
        }
      }
    },
    validarCampos () {
      if (
        this.form.diaDespacho === '' ||
        this.form.diaCredito === '' ||
        this.productos.length === 0
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },

    close2 () {
      this.dialog2 = false
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
      }, 300)
      this.$emit('close')
    },

    agregar () {
      if (this.seleccion && this.cantidad && this.costo) {
        this.productos.push(
          {
            prod: {
              _id: this.seleccion,
              descripcion: this.descripcion
            },
            cantidad: this.cantidad,
            costo: this.costo
          }
        )
        for (let i = 0; i < this.selectpro.length; i++) {
          if (this.seleccion === this.selectpro[i].value) {
            this.selectpro.splice(i, 1)
          }
        }
        this.seleccion = ''
        this.cantidad = ''
        this.descripcion = ''
        this.costo = ''
        this.dialog2 = false
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error al guardar',
          text: 'Por favor, verifique los datos e intente de nuevo'
        })
      }
    },

    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        this.form.idProveedor = this.$store.state.usuario._id
        let acum = 0
        for (let i = 0; i < this.productos.length; i++) {
          this.form.productos.push({ idProducto: this.productos[i].prod._id, cantidad: this.productos[i].cantidad, costo: this.productos[i].costo })
          acum = parseInt(acum) + parseInt(this.productos[i].costo)
        }
        this.form.total = acum
        this.form.idOrden = this.orden._id
        Api.post('ordenCotizada', this.form)
          .then(res => {
            this.$swal({
              icon: 'success',
              title: 'Cotización exitosa',
              text: 'Todos los datos han sido guardados'
            }).then(result => {
              if (result) {
                this.close()
                window.location.reload()
              }
            })
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
      }
    }
  }
}
</script>
